import React, {memo} from 'react';
import './CartMap.less';

import {Map} from 'elements/map/Map';
import {GeolocationLink} from "../../elements/geolocation-link/GeolocationLink";

export const CartMap = memo(({latitude, longitude, address, zip}) => {
	return (
		<div className="cart-map">
      <span className="cart-map__map">
				<GeolocationLink
					latitude={latitude}
					longitude={longitude}
					address={address}
					zip={zip}
				>
					<Map
						latitude={latitude}
						longitude={longitude}
					/>
				</GeolocationLink>
      </span>
		</div>
	);
});
